import React from 'react';
import { useTranslation } from 'react-i18next';

const DashboardPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <h2>{t('dashboard.title')}</h2>
      <p>{t('dashboard.description')}</p>
      {/* TODO: Add calendar, deadlines, and document list */}
    </div>
  );
};

export default DashboardPage;
